import routes from 'app/instant-zap/routes';

export default {
  routes,
};
